// Polyfills for Internet Explorer 11 Support
import 'babel-polyfill'

// Vue
import Vue from 'vue'
Vue.config.productionTip = false
Vue.prototype.window = window;

// Vue Global Mixins & Plug-ins
import fnHash from './mixins/fnHash.js'
Vue.mixin(fnHash); // 모든 컴포넌트에 hash 메써드를 주입한다. hash 메써드는 컴포넌트 템플릿에 key값으로 사용하고, 데이터가 바뀔 때 리렌더링을 유발하기 위함이다.
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
import VModal from 'vue-js-modal'
Vue.use(VModal)
import fnMoment from './mixins/fnMoment.js'
Vue.mixin(fnMoment) // 모멘트js 의존성 추가
// 회원가입 믹스인 추가
import fnAccessToken from './mixins/fnAccessToken.js'
Vue.mixin(fnAccessToken);

// Test Components
import ModalSamples from './views/ModalSamples.vue'

// View Components
import ViewLogin from './views/ViewLogin.vue'
// Main
import ViewMain from './views/ViewMain.vue'
// counsel
import ViewCounselList from './views/ViewCounselList.vue'
import ViewCounselDetail from './views/ViewCounselDetail.vue'
import ViewCounselWrite from './views/ViewCounselWrite.vue'
import ViewCounselStatistics from './views/ViewCounselStatistics.vue'
// board
import ViewBoardList from './views/ViewBoardList.vue'
import ViewBoardRegister from './views/ViewBoardRegister.vue'
import ViewBoardDetail from './views/ViewBoardDetail.vue'
import ViewBoardModify from './views/ViewBoardModify.vue'
import ViewBoardSettingModify from './views/ViewBoardSettingModify.vue'
import ViewBoardWrite from './views/ViewBoardWrite.vue'
// 사이트관리
import ViewSiteList from './views/ViewSiteList.vue'
import ViewSiteRegister from './views/ViewSiteRegister.vue'
import ViewSiteDetail from './views/ViewSiteDetail.vue'
import ViewSiteModify from './views/ViewSiteModify.vue'
import ViewSiteSettingModify from './views/ViewSiteSettingModify.vue'
import ViewSiteWrite from './views/ViewSiteWrite.vue'

// 로그관리
import ViewLogList from './views/ViewLogList.vue'

// 메뉴관리
import ViewMenuManager from './views/ViewMenuManager.vue'

// 신청안내, 카테리리
import ViewGuideApply from './views/ViewGuideApply.vue' // 교육과정관리 > 신청안내설정
import ViewCategoryManager from './views/ViewCategoryManager.vue'

// start - 강의실 Component
import ViewClassroomCurriculum from './views/ViewClassroomCurriculum.vue' // 강의실 > 커리큘럼(목차) 화면
import ViewClassroomApplyList from './views/ViewClassroomApplyList.vue' // 강의실 > 수강현황 > 수강 신청관리 화면 화면
import ViewClassroomProgressList from './views/ViewClassroomProgressList.vue' // 강의실 > 수강현황 > 수강현황관리 화면

import ViewClassroomAttendance from './views/ViewClassroomAttendance.vue' // 강의실 > 출결 > 출결현황 화면

import ViewClassroomAssignmentList from './views/ViewClassroomAssignmentList.vue' // 강의실 > 과제 > 과제목록 화면
import ViewClassroomAssignmentDetail from './views/ViewClassroomAssignmentDetail.vue' // 강의실 > 과제 > 과제상세 화면
import ViewClassroomAssignmentRegister from './views/ViewClassroomAssignmentRegister.vue' // 강의실 > 과제 > 과제등록 화면
import ViewClassroomAssignmentModify from './views/ViewClassroomAssignmentModify.vue' // 강의실 > 과제 > 과제수정 화면

import ViewClassroomExamList from './views/ViewClassroomExamList.vue' // 강의실 > 시험 > 시험목록 화면
import ViewClassroomExamRegister from './views/ViewClassroomExamRegister.vue' // 강의실 > 시험 > 시험생성 화면, 시험수정 화면
import ViewClassroomExamModify from './views/ViewClassroomExamModify.vue' // 강의실 > 시험 > 시험수정 화면
import ViewClassroomExamDetail from './views/ViewClassroomExamDetail.vue' // 강의실 > 시험 > 시험상세 및 응시현황 화면
import ViewClassroomExamResult from './views/ViewClassroomExamResult.vue' // 강의실 > 시험 > 시험상세 > 응시현황중 결과보기 화면

import ViewClassroomSurveyList from './views/ViewClassroomSurveyList.vue' // 강의실 > 설문 > 설문목록 화면
import ViewClassroomSurveyRegister from './views/ViewClassroomSurveyRegister.vue' // 강의실 > 설문 > 설문생성 화면, 설문수정 화면
import ViewClassroomSurveyModify from './views/ViewClassroomSurveyModify.vue' // 강의실 > 설문 > 설문수정 화면
import ViewClassroomSurveyDetail from './views/ViewClassroomSurveyDetail.vue' // 강의실 > 설문 > 설문상세 및 응답현황 화면
import ViewClassroomSurveyResult from './views/ViewClassroomSurveyResult.vue' // 강의실 > 설문 > 설문상세 > 응답현황중 결과보기 화면

import ViewClassroomBoardRegister from './views/ViewClassroomBoardRegister.vue' // 강의실 > 게시판 > 게시판만들기 화면 (notice-add.html)
import ViewClassroomBoardList from './views/ViewClassroomBoardList.vue' // 강의실 > 게시판 > 게시물목록 화면 (notice.html)
import ViewClassroomBoardSettingModify from './views/ViewClassroomBoardSettingModify.vue' // 강의실 > 게시판 > 게시판 설정 수정화면
import ViewClassroomBoardDetail from './views/ViewClassroomBoardDetail.vue' // 강의실 > 게시판 > 게시물보기 화면 (notice-detail.html)
import ViewClassroomBoardWrite from './views/ViewClassroomBoardWrite.vue' // 강의실 > 게시판 > 게시물작성 화면 (notice-write.html, notice-write2.html)
import ViewClassroomBoardModify from './views/ViewClassroomBoardModify.vue' // 강의실 > 게시판 > 게시물수정 화면 (notice-write.html, notice-write2.html)

import ViewSurveyList2 from './views/ViewSurveyList2.vue' // 강의실 > 설문 > 관리자 직권 설문응답 입력 화면 (survey-direct.html)
import ViewSurveyRegister from './views/ViewSurveyRegister.vue' // 강의실 > 설문 > 관리자 직권 설문응답 입력 화면 (survey-direct.html)
import ViewSurveyModify from './views/ViewSurveyModify.vue' //  헤더 > 설문 > 수정
import ViewSurveyManual from './views/ViewSurveyManual.vue' // 강의실 > 설문 > 관리자 직권 설문응답
import ViewSurveyResult from './views/ViewSurveyResult.vue' // 강의실 > 설문 > 결과보기 화면 (survey-result.html)
// end 강의실 Component
import ViewUserStudentList from './views/ViewUserStudentList.vue'
import ViewUserSysList from './views/ViewUserSysList.vue'
import ViewUserTeacherList from './views/ViewUserTeacherList.vue'
import ViewUserAdminList from './views/ViewUserAdminList.vue'
import ViewUserDetail from './views/ViewUserDetail.vue'
import ViewFilterList from './views/ViewFilterList.vue'
import ViewEmailFormList from './views/ViewEmailFormList.vue'
import ViewEmailSentList from './views/ViewEmailSentList.vue'
import ViewPermissionManager from './views/ViewPermissionManager.vue'
import ViewPermissionList from './views/ViewPermissionList.vue'
import ViewSmsFormList from './views/ViewSmsFormList.vue'
import ViewSmsSentList from './views/ViewSmsSentList.vue'
import ViewInstitutionList from './views/ViewInstitutionList.vue'
import ViewClassList from './views/ViewClassList.vue'
import ViewClassApplyList from './views/ViewClassApplyList.vue'
import ViewClassProgressList from './views/ViewClassProgressList.vue'
import ViewClassRegister from './views/ViewClassRegister.vue'
import ViewClassDefault from './views/ViewClassDefault.vue'
import ViewExamCategoryManager from './views/ViewExamCategoryManager.vue'
import ViewExamList from './views/ViewExamList.vue'
import ViewSurveyCategoryManager from './views/ViewSurveyCategoryManager.vue'
import ViewSurveyList from './views/ViewSurveyList.vue'
import ViewSurveyItemList from './views/ViewSurveyItemList.vue'
import ViewSurveyAppl from './views/ViewSurveyAppl.vue'
import ViewSurveyRegi from './views/ViewSurveyRegi.vue'
import ViewPopupManager from './views/ViewPopupManager.vue'
import ViewAddressSearch from './views/ViewAddressSearch.vue'

// Subview Components
import SubviewUserDetail from './views/subviews/SubviewUserDetail.vue'
import SubviewUserDetailModify from './views/subviews/SubviewUserDetailModify.vue'
import SubviewUserDetailApply from './views/subviews/SubviewUserDetailApply.vue'
import SubviewUserDetailProgress from './views/subviews/SubviewUserDetailProgress.vue'
// import SubviewUserDetailQna from './views/subviews/SubviewUserDetailQna.vue'
// import SubviewUserDetailQnaDetail from './views/subviews/SubviewUserDetailQnaDetail.vue'
// import SubviewUserDetailArticles from './views/subviews/SubviewUserDetailArticles.vue'
// import SubviewUserDetailComments from './views/subviews/SubviewUserDetailComments.vue'

// Vue-Router
import VueRouter from 'vue-router'
Vue.use(VueRouter);
const router = new VueRouter({
	routes: [
		{ path: '/main', component: ViewMain },

		{
			path: '/users/detail/:id',
			component: ViewUserDetail,
			children: [
				{ path: "", component: SubviewUserDetail }, // 회원관리 > 회원상세정보 > 회원정보
				{ path: "modify", component: SubviewUserDetailModify }, // 회원관리 > 회원상세정보 > 회원정보수정
				{ path: "apply", component: SubviewUserDetailApply }, // 회원관리 > 회원상세정보 > 수강 신청목록
				{ path: "progress", component: SubviewUserDetailProgress }, // 회원관리 > 회원상세정보 > 수강현황
				// { path: "qna", component: SubviewUserDetailQna }, // 회원관리 > 회원상세정보 > 1:1 문의
				// { path: "qna/:articleId", component: SubviewUserDetailQnaDetail }, // 회원관리 > 회원상세정보 > 1:1 문의 > 상세 보기
				// { path: "articles", component: SubviewUserDetailArticles }, // 회원관리 > 회원상세정보 > 작성한 게시물
				// { path: "comments", component: SubviewUserDetailComments }, // 회원관리 > 회원상세정보 > 작성한 댓글
			]
		}, // 회원관리 > 회원상세정보

		{ path: '/users', redirect: '/users/admins' },
		{ path: '/users/students', component: ViewUserStudentList }, // 회원관리 > 수강생관리
		{ path: '/users/teachers', component: ViewUserTeacherList }, // 회원관리 > 강사관리
		{ path: '/users/admins', component: ViewUserAdminList }, // 회원관리 > 관리자관리
		{ path: '/users/sys', component: ViewUserSysList }, // 회원관리 > 비회원관리

		{ path: '/classes', component: ViewClassList }, // 강좌관리 > 강의목록
		{ path: '/classes/apply', component: ViewClassApplyList }, // 강좌관리 > 수강 신청관리
		{ path: '/classes/progress', component: ViewClassProgressList }, // 강좌관리 > 수강현황관리

		{ path: '/counsel/:counselId', component: ViewCounselList }, // 상담관리 > 게시물 목록
		{ path: '/counsel', component: ViewCounselList }, // 상담관리 > 게시물 목록
		{ path: '/counsel/:counselId/detail/:articleId', component: ViewCounselDetail }, // 상담관리 > 게시물 상세
		{ path: '/counsel/:counselId/write/:parentsId', component: ViewCounselWrite }, // 상담관리 > 게시물 작성
		{ path: '/counsel/:counselId/write', component: ViewCounselWrite }, // 상담관리 > 게시물 작성
		{ path: '/counselStatistics', component: ViewCounselStatistics }, // 상담관리 > 상담통계

		{ path: '/board/register', component: ViewBoardRegister }, // 게시판관리 > 게시판 생성
		{ path: '/board/:boardId/modify', component: ViewBoardSettingModify }, // 게시판 관리 > 게시판 설정수정
		{ path: '/board/:boardId', component: ViewBoardList }, // 게시판관리 > 게시물 목록
		{ path: '/board', component: ViewBoardList }, // 게시판관리 > 게시물 목록
		{ path: '/board/:boardId/detail/:articleId/modify', component: ViewBoardModify }, // 게시판관리 > 게시물 수정
		{ path: '/board/:boardId/detail/:articleId', component: ViewBoardDetail }, // 게시판관리 > 게시물 상세
		{ path: '/board/:boardId/write/:parentsId', component: ViewBoardWrite }, // 게시판관리 > 게시물 작성
		{ path: '/board/:boardId/write', component: ViewBoardWrite }, // 게시판관리 > 게시물 작성

		{ path: '/classes/register', component: ViewClassRegister }, // 강의생성

		// { path: '/site', redirect: '/site/1' }, // 사이트관리
		// { path: '/site/:siteId', component: ViewSite }, // 사이트관리 > 1

		{ path: '/site/register', component: ViewSiteRegister }, // 사이트관리 > 사이트 생성
		{ path: '/site/:boardId/modify', component: ViewSiteSettingModify }, // 사이트 관리 > 사이트 설정수정
		{ path: '/site/:boardId', component: ViewSiteList }, // 사이트관리 > 게시물 목록
		{ path: '/site', component: ViewSiteList }, // 사이트관리 > 게시물 목록
		{ path: '/log', component: ViewLogList }, // 사이트관리 > 로그 관리
		{ path: '/site/:boardId/detail/:articleId/modify', component: ViewSiteModify }, // 사이트관리 > 게시물 수정
		{ path: '/site/:boardId/detail/:articleId', component: ViewSiteDetail }, // 사이트관리 > 게시물 상세
		{ path: '/site/:boardId/write/:parentsId', component: ViewSiteWrite }, // 사이트관리 > 게시물 작성
		{ path: '/site/:boardId/write', component: ViewSiteWrite }, // 사이트관리 > 게시물 작성

		{ path: '/menu', component: ViewMenuManager }, // 메뉴관리

		{ path: '/email/forms', component: ViewEmailFormList }, // 전자우편관리 > 전자우편양식관리
		{ path: '/email/sents', component: ViewEmailSentList }, // 전자우편관리 > 보낸우편함
		{ path: '/sms/forms', component: ViewSmsFormList }, // 문자관리 > 문자양식관리
		{ path: '/sms/sents', component: ViewSmsSentList }, // 문자관리 > 보낸문자함

		{ path: '/institutions', component: ViewInstitutionList }, // 강의지원 > 기관관리

		{ path: '/guides/apply', component: ViewGuideApply }, // 교육관리 > 신청안내
		{ path: '/categories', component: ViewCategoryManager }, // 교육관리 > 교육과정분류편집
		{ path: '/default', component: ViewClassDefault }, // 교육관리 > 강좌개설초기값

		{ path: '/exams/categories', component: ViewExamCategoryManager }, // 시험관리 > 시험분류
		{ path: '/exams', component: ViewExamList }, // 시험관리 > 시험문항 관리

		{ path: '/surveys/categories', component: ViewSurveyCategoryManager }, // 설문관리 > 설문분류
		{ path: '/surveys', component: ViewSurveyList }, // 설문관리 > 설문 관리\
		{ path: '/surveys/register/', component: ViewSurveyRegister }, // 설문관리 > 설문 관리 > 설문작성
		{ path: '/surveys/modify/:surveyId', component: ViewSurveyModify }, // 설문관리 > 설문 관리 > 설문수정
		{ path: '/surveyItems', component: ViewSurveyItemList }, // 설문관리 > 설문문항 관리\
		{ path: '/surveys/register/:surveyId', component: ViewSurveyRegi }, // 설문관리 > 설문 결과
		{ path: '/surveys/statistics', component: ViewSurveyAppl }, // 설문관리 > 설문 결과

		{ path: '/permissions/list', component: ViewPermissionList }, // 권한관리 > 권한편집
		{ path: '/permissions', component: ViewPermissionManager }, // 권한관리 > 권한관리

		{ path: '/popup', component: ViewPopupManager }, // 팝업관리

		{ path: '/classroom/:lecId/curriculum', component: ViewClassroomCurriculum }, // 강의실 > 커리큘럼(목차)
		{ path: '/classroom/:lecId/apply', component: ViewClassroomApplyList }, // 강의실 > 수강현황 > 수강 신청관리 화면
		{ path: '/classroom/:lecId/progress', component: ViewClassroomProgressList }, // 강의실 > 수강현황 > 수강현황관리 화면

		{ path: '/classroom/:lecId/exam', component: ViewClassroomExamList }, // 강의실 > 시험 > 목록 화면
		{ path: '/classroom/:lecId/exam/register/:curriculumId', component: ViewClassroomExamRegister }, // 강의실 > 시험 > 시험생성 화면
		{ path: '/classroom/:lecId/exam/:examId/modify', component: ViewClassroomExamModify }, // 강의실 > 시험 > 시험수정 화면
		{ path: '/classroom/:lecId/exam/:examId/detail', component: ViewClassroomExamDetail }, // 강의실 > 시험 > 시험상세 및 응시현황 화면
		{ path: '/classroom/:lecId/exam/:examId/result', component: ViewClassroomExamResult }, // 강의실 > 시험 > 시험상세 > 응시현황중 결과보기 화면

		{ path: '/classroom/:lecId/survey', component: ViewClassroomSurveyList }, // 강의실 > 설문 > 목록 화면
		{ path: '/classroom/:lecId/survey/register/:curriculumId', component: ViewClassroomSurveyRegister }, // 강의실 > 설문 > 설문생성 화면
		{ path: '/classroom/:lecId/survey/:surveyId/modify', component: ViewClassroomSurveyModify }, // 강의실 > 설문 > 설문수정 화면
		{ path: '/classroom/:lecId/survey/:surveyId/detail', component: ViewClassroomSurveyDetail }, // 강의실 > 설문 > 설문상세 및 응답현황 화면
		{ path: '/classroom/:lecId/survey/:surveyId/result', component: ViewClassroomSurveyResult }, // 강의실 > 설문 > 설문상세 > 응답현황중 결과보기 화면

		{ path: '/classroom/:lecId/board', component: ViewClassroomBoardList }, // 강의실 > 게시판 > 게시물목록 화면
		{ path: '/classroom/:lecId/board/:boardId/modify', component: ViewClassroomBoardSettingModify }, // 강의실 > 게시판 > 게시판 설정 수정화면
		{ path: '/classroom/:lecId/board/register', component: ViewClassroomBoardRegister }, // 강의실 > 게시판 > 게시판만들기 화면 (notice-add.html)
		{ path: '/classroom/:lecId/board/:boardId', component: ViewClassroomBoardList }, // 강의실 > 게시판 > 게시물목록 화면
		{ path: '/classroom/:lecId/board/:boardId/detail/:articleId/modify', component: ViewClassroomBoardModify }, // 강의실 > 게시판 > 게시물수정 화면
		{ path: '/classroom/:lecId/board/:boardId/detail/:articleId', component: ViewClassroomBoardDetail }, // 강의실 > 게시판 > 게시물보기 화면
		{ path: '/classroom/:lecId/board/:boardId/write/:parentsId', component: ViewClassroomBoardWrite }, // 게시판 > 답글작성 화면
		{ path: '/classroom/:lecId/board/:boardId/write', component: ViewClassroomBoardWrite }, // 게시판 > 게시물작성 화면

		{ path: '/classroom/:lecId/attendance', component: ViewClassroomAttendance }, // 강의실 > 출결 화면

		{ path: '/classroom/:lecId/assignment', component: ViewClassroomAssignmentList }, // 강의실 > 과제 목록화면
		{ path: '/classroom/:lecId/assignment/register/:curriculumId', component: ViewClassroomAssignmentRegister }, // 강의실 > 과제 생성화면
		{ path: '/classroom/:lecId/assignment/:assignId', component: ViewClassroomAssignmentDetail }, // 강의실 > 과제 상세화면
		{ path: '/classroom/:lecId/assignment/:assignId/modify', component: ViewClassroomAssignmentModify }, // 강의실 > 과제 수정화면

		{ path: '/classroom/survey/list', component: ViewSurveyList2 }, // 강의실 > 설문 > 결과보기 화면
		{ path: '/classroom/survey/register', component: ViewSurveyRegister }, // 설문 > 설문생성 화면, 설문수정 화면
		{ path: '/classroom/survey/manual', component: ViewSurveyManual }, // 관리자 직권 설문응답 입력 화면
		{ path: '/classroom/survey/result', component: ViewSurveyResult }, // 강의실 > 설문 > 결과보기 화면

		{ path: '/addressSearch', component: ViewAddressSearch }, // 주소찾기 팝업창
		{ path: '/filters', component: ViewFilterList }, // 목록필터관리
		{ path: "/samples", component: ModalSamples }, // 모달 샘플페이지
		{ path: '*', component: ViewLogin },
	]
});

// Launch app
const mainVue = new Vue({
	router
})
// access token을 쿠키에서 가져오는 함수
mainVue.tokenInitializer();

// 어플리케이션 마운트
mainVue.$mount('#wrap');
